<div class="ui-g-12 ui-md-12">
  <div *ngIf="!mostrar">
      <i class="pi pi-spin pi-spinner" style="font-size: 5em"></i>

  </div>
  <div *ngIf="mostrar">

      <div class="">
          <app-simple-table 
                [cols]="cols" 
                [showInfo]="showInfo" 
                [mostrarInformes]="mostrarInformes" 
                [listarTodos]="listarTodos"  
                [items]="control" 
                [database]="database"  
                [showDuplicate]="showDuplicate" 
                (listarCamposEmmit)="listarCampos()" 
                (iniciarEmmit)="iniciar()" 
                (deleteEmmit)="delete($event)" 
                (duplicateEmmit)="duplicate($event)">
            </app-simple-table>
          <br>

      </div>

  </div>
</div>
<p-confirmDialog header="Confirmación" icon="pi pi-exclamation-triangle"></p-confirmDialog>


<p-toast [style]="{marginTop: '80px'}"></p-toast>